import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withRouter from 'react-router/withRouter';
import AdContainer from '../../../components/ad/AdContainer';
import clsx from 'clsx';

const DEFAULT_YEAR = 2026;

const InnovationByDesignSplashPage = ({
  match: {
    params: { year }
  },
  franchisePage
}) => {
  const thisYear = year === 'list' ? DEFAULT_YEAR : year;

  const metadata = franchisePage?.data?.externalList?.pageMeta?.[0] || {};
  metadata['Splash Page Copy'] =
    metadata['Splash Page Copy'] ||
    'The 2026 Innovation By Design list will be available on Monday, September 14, 2026, at 7am';
  metadata['Splash Page Button CTA'] =
    metadata['Splash Page Button CTA'] || `See Last Year's List`;
  metadata['Splash Page Application CTA'] =
    metadata['Splash Page Application CTA'] || 'Apply to the 2027 List';
  metadata.registerURL =
    metadata.registerURL ||
    'https://www.fastcompany.com/apply/innovation-by-design';

  return (
    <main id={`ibd__splashPage--${thisYear}`}>
      <section className={clsx(['content'])}>
        <div className={clsx(['container'])}>
          <img
            src="https://assets.fastcompany.com/image/upload/v1720573320/ibd_logo_color_large.svg"
            alt={`Innovation by Design ${thisYear}`}
          />
          <div className={clsx(['information'])}>
            <div className={clsx(['coming-soon'])}>Coming Soon</div>

            <div className={clsx(['copy'])}>
              {metadata['Splash Page Copy'] || ''}
            </div>

            <div className={clsx(['last-year-cta'])}>
              {metadata['Splash Page Button CTA'] && (
                <a
                  href={`/innovation-by-design/${thisYear - 1}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {metadata['Splash Page Button CTA']}
                </a>
              )}
            </div>

            <div className={clsx(['application-cta'])}>
              {metadata.registerURL &&
                metadata['Splash Page Application CTA'] && (
                  <a
                    href={metadata.registerURL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {metadata['Splash Page Application CTA']} {'→'}
                  </a>
                )}
            </div>
          </div>
        </div>
      </section>

      <AdContainer type="footer" />
    </main>
  );
};

function mapStateToProps(state = {}) {
  return {
    franchisePage: state.franchisePage
  };
}

InnovationByDesignSplashPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired
  }).isRequired,
  franchisePage: PropTypes.shape({}).isRequired
};

export default withRouter(
  connect(mapStateToProps)(InnovationByDesignSplashPage)
);
